import React, { Component } from 'react'
import { connect } from 'react-redux'
import './Bloc.css'

class BlocConseilExpert extends Component {
    handleClick(link) {
        window.open(link, '_blank')
    }

    render() {
        return (
            <div>
                <div className="Bloc fade-in bloc-full BlocConseilExpert">
                    <div className="ligne1 size14 bold-font">
                        {' '}
                        D'un conseil d'expert{' '}
                    </div>
                    <div className="ligne2 size11">
                        et j'obtiens mon attestation de capacité d'emprunt
                    </div>
                    <button
                        className="button_rdv"
                        onClick={(e) =>
                            this.handleClick(
                                'https://calendly.com/' +
                                    this.props.resultat_affected_calendly
                            )
                        }
                    >
                        Prendre rendez vous avec{' '}
                        {this.props.resultat_affected_name} !
                    </button>
                    <div className="bottomImageContainer">
                        <img
                            src="svg/expert.svg"
                            className="expert"
                            alt="expert"
                        />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        resultat_affected_calendly: state.answer.resultat_affected_calendly,
        resultat_affected_name: state.answer.resultat_affected_name,
    }
}

export default connect(mapStateToProps)(BlocConseilExpert)
